import React from 'react';
import WebModal from './Modal';
import { useTranslation } from 'react-i18next';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { Button } from 'aha-components';
import { isMobile } from '@/biz/tool';
import { formattedDate, getTimezoneName } from '@/biz/time';
import PromotionalLinkCopy from './ModalPromotionalLinkEducation/PromotionalLinkCopy';
import { HelpIcon } from '@/components/common/icon';

interface Props {}

const ModalPublishTime: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { detailData } = useDetailDataStore();
  const {
    showModalPublishTime,
    setShowModalPublishTime,
    setShowPromotionalLinkEducationModal
  } = useWebModalStore();

  return (
    <>
      <WebModal
        width={isMobile() ? 380 : 570}
        visible={showModalPublishTime}
        isShowHeader={false}
        isShowFooter={false}
      >
        <div className="w-full max-h-[70vh] overflow-y-auto">
          <div className="self-stretch text-center justify-start text-text-color-primary text-xl font-semibold leading-loose">
            {t('modal.publish_time.title', {
              defaultValue: 'Congratulations!'
            })}
          </div>
          <div className="mb-5 justify-start text-center text-base font-medium leading-normal">
            {t('modal.publish_time.content', {
              defaultValue: 'Your content draft was approved by the brand.'
            })}
          </div>
          <div className="w-full self-stretch px-6 pt-6 pb-8 bg-[#F9F9FB] rounded-2xl inline-flex flex-col justify-start items-start gap-2">
            <div className="justify-start text-[#1C2024] text-base font-medium leading-normal">
              {t('modal.publish_time.content_title', {
                defaultValue: 'Next step: Publish the content'
              })}
            </div>
            <div className="flex flex-col gap-2">
              <div className="self-stretch justify-start">
                <span className="text-[#57534D] text-sm font-normal font-['Inter'] leading-snug">
                  {t('modal.publish_time.content_text_1', {
                    defaultValue: 'The brand has '
                  })}
                </span>
                <span className="text-blue-600 text-sm font-normal font-['Inter'] leading-snug">
                  {t('modal.publish_time.content_text_2', {
                    defaultValue: 'updated the content publish deadline.'
                  })}
                </span>
                <span className="text-[#57534D] text-sm font-normal font-['Inter'] leading-snug">
                  {t('modal.publish_time.content_text_4', {
                    defaultValue:
                      ' Please make sure to submit your content within the required timeframe.'
                  })}
                  <br />
                  <br />
                  {t('modal.publish_time.content_text_5', {
                    defaultValue: 'Make sure to include '
                  })}
                  <PromotionalLinkCopy utmLink={detailData?.order?.utmLink} />
                  {t('modal.publish_time.content_text_6', {
                    defaultValue:
                      ", as per the platform's rules, when submitting the final link to your published content to receive full payment."
                  })}
                </span>
              </div>
              <div
                className="flex items-center gap-1.5 cursor-pointer"
                onClick={() => setShowPromotionalLinkEducationModal(true)}
              >
                <HelpIcon className="w-4 h-4 text-[#155DFC]" />
                <div className="justify-start text-[#155DFC] text-xs font-normal font-['Inter']">
                  {t('modal.publish_time.help_text', {
                    defaultValue: 'How to place promotional link'
                  })}
                </div>
              </div>
            </div>
          </div>
          {detailData?.order?.postTimeRange?.length > 0 && (
            <div className="mt-2 bg-[#F9F9FB] rounded-[12px] p-[18px] flex flex-col gap-2">
              <div className="self-stretch justify-start text-text-color-primary text-base font-semibold font-['DM_Sans'] leading-normal">
                {t('modal.publish_time.publish_date', {
                  defaultValue: 'Publish date'
                })}
              </div>
              <div className="text-[#5A31F0] self-stretch text-2xl font-semibold leading-9">
                {formattedDate(detailData?.order?.postTimeRange?.[0])} -{' '}
                {formattedDate(detailData?.order?.postTimeRange?.[1])}
              </div>
              {detailData?.order?.postTimeRange?.length > 1 ? (
                <div className="justify-start text-[#525252] text-xs font-normal leading-none">
                  (
                  {getTimezoneName(
                    formattedDate(detailData?.order?.postTimeRange?.[1])
                  )}
                  )
                </div>
              ) : null}
            </div>
          )}
          <div className="mt-8 flex justify-center">
            <Button
              type="primary"
              className="!w-full"
              onClick={() => {
                setShowModalPublishTime(false);
                if (!detailData?.influencer?.hasCollaborated) {
                  setShowPromotionalLinkEducationModal(true);
                }
              }}
            >
              {!detailData?.influencer?.hasCollaborated
                ? t('modal.publish_time.btn_learn_content', {
                    defaultValue: 'Learn how to place promotional link'
                  })
                : t('modal.publish_time.btn_content', {
                    defaultValue: 'Confirm'
                  })}
            </Button>
          </div>
        </div>
      </WebModal>
    </>
  );
};

export default ModalPublishTime;
